/* oxlint-disable react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md */
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, TextButton, modals } from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import type { PharmacyProviderInfoFragment } from '../../../graphql/generated/graphql';

import { MoreProvidersDialog } from './MoreProvidersDialog';

export const MoreProviders = ({
    primaryName,
    moreProviders,
    onSelected,
}: {
    primaryName: string;
    moreProviders: PharmacyProviderInfoFragment[];
    onSelected?: (providerId: string) => void;
}) => {
    if (!moreProviders.length) {
        return null;
    }
    const [dialogOpen, { open, close }] = useDisclosure(false);
    const { t } = useTranslation();

    const selectedLocation = useCallback(
        (id: string) => {
            if (onSelected) {
                onSelected(id);
                modals.closeAll();
            }
        },
        [onSelected]
    );

    return (
        <Flex
            align="flex-start"
            onClick={(event: React.MouseEvent) => {
                // Must stop event propagation as entire card is clickable
                event.stopPropagation();
            }}
        >
            <TextButton
                onClick={(event: React.MouseEvent) => {
                    event.stopPropagation();
                    open();
                }}
            >
                {t('offerPharmacyCard.showMoreProviders', {
                    count: moreProviders.length,
                })}
            </TextButton>
            <MoreProvidersDialog
                title={primaryName}
                isOpen={dialogOpen}
                close={close}
                moreProviders={moreProviders}
                onSelected={onSelected ? selectedLocation : undefined}
            />
        </Flex>
    );
};
